<template>
  <div class="intelligentAgriculture-page">
    <!-- 数字乡村-->
    <div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    	<div class="main">
            <div class="top-banner">
                <h2 style="font-size: 56px;
    font-weight: 500;
    position: absolute;
    color: #fff;
    left: 15%;
    top: 331px;">智慧养老解决方案</h2>
                <h2 style="font-size: 42px;
    font-weight: 500;
    position: absolute;
    color: #fff;
    left: 15%;
    top: 432px;">Smart pension solutions</h2>
                <img style="width:100%;height:auto" src="../../assets/img/caseDetails/smartpensionsolutions/banner.png">            
            </div>
            <div class="mid-body"  style="background:#fff;margin-bottom: 0;padding-top: 40px;">
                <div class="mid-body-box">
                    <i class="left-line"></i>
                    <i class="right-line"></i>
                    <h2 style="text-align: center;margin-bottom: 50px;margin-top: 20px;font-size: 28px;font-weight: 700;">百倍云智慧养老解决方案</h2>

                    <img style="width:100%;height:auto" src="../../assets/img/caseDetails/smartpensionsolutions/index01.png">      
                </div>    
            </div> 
             <div class="mid-body">
                <div class="mid-body-box" style="margin-top:80px">
                    <h2 style="text-align: center;margin-bottom: 30px;margin-top: 40px;font-size: 32px;font-weight: 500;position:absolute;top:-65px">智慧养老小程序</h2>
                    <div>                                                                    
                        <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/smartpensionsolutions/index02.png">   
                        <div style="width:345px;float:right;    text-align: right;
    position: absolute;
    bottom: 66px;
    right: 373px;">
                            <p style="font-size: 24px;font-weight:700">首页</p> 
                            <p style="margin-bottom: 20px;font-size: 16px;font-weight: 500;margin-top: 16px;color: #333;line-height: 30px;">实时监测老人身体各项常规指标，家庭成员同 步数据更新，手环定位功能，实时查看人员活 动轨迹，位置导航功能方便应急处理</p>        
                        </div>                       
                    </div>
                </div>    
            </div> 

         
            
             <div class="mid-body" style="position:relative;height:820px">
               <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/shuzixiangcun/index04.png">    
                <div class="mid-body-box" style="    position: absolute;
    top: 80px;
    left: 50%;
    margin-left: -600px;">
                    
                    <div> 
                        <!-- <div style="height:700px"> </div>          -->
                        <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/shuzixiangcun/index6.png">                                   
                         <div class="three-boxs" style="padding: 10px 66px;"> 
                            <p style="margin-bottom: 20px;font-size: 16px;font-weight: 700;margin-top: 36px; text-align:left">手环定位</p>
                            <p style="font-size: 14px;letter-spacing: 1px;color:#999;text-align:left">手环定位，可查询运动轨迹，可添加多位家庭 成员，实时数据同步更新，贴心守护更方便</p>
                        </div>    
                        <div class="three-boxs" style="padding: 10px 66px;"> 
                            <p style="margin-bottom: 20px;font-size: 16px;font-weight: 700;margin-top: 36px;text-align:left">健康护理</p>
                            <p style="font-size: 14px;letter-spacing: 1px;color:#999;text-align:left">养生知识共享，专业护理在线支持</p>
                        </div>  
                        <div class="three-boxs" style="padding: 10px 86px;"> 
                            <p style="margin-bottom: 20px;font-size: 16px;font-weight: 700;margin-top: 36px;text-align:left">一键呼叫</p>
                            <p style="font-size: 14px;letter-spacing: 1px;color:#999;text-align:left">老人可以使用跌倒呼救器或者按键手环进行 主动呼叫，根据客户需求灵活选择终端类型。</p>
                        </div>
                              
                    </div>
                </div>    
            </div>       
		</div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'  

export default {
  name: 'intelligentAgriculture',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {
        select:1,
    }
  },
  mounted() {
  },
  methods: {
      clicknav(e){
          this.select = e
      }
  }
}
</script>
<style>
    .banner-title{
        width: 490px;
        height: 120px;
        position: absolute;
        top: 50%;
        right: 50%;
        margin-top: 40px;
    }
    .mid-body{
        margin-bottom: 120px;
    }
    .mid-body-box{
        width: 1200px;
        margin: auto;
        position: relative;
    }
    .four-box{
        width: 25%;
        float: left;
        text-align: center;
        box-sizing: border-box;
        padding: 30px;
        box-sizing: border-box;
    }
    .list-box{
     box-sizing: border-box;
    padding: 20px;
    position: relative;
    text-align: left;
    padding-left: 240px;
        
    }
    .list-box img{
        width: 24px;
        height: auto;
        position: absolute;
        left: 190px;
        top: 21px;
    }
     .list-box p{
        margin-bottom: 14px;
    }
    .five-box{
        width: 20%;
        float: left;
        text-align: center;
        box-sizing: border-box;
        padding: 30px;
        box-sizing: border-box;
        padding-bottom: 0;
    }
    .five-box img{
            width: 50px;
    height: auto;
    margin: auto;
    cursor: pointer;
    }
        .five-box span{
         display: inline-block;
        padding-top: 22px;
        padding-bottom: 32px;
        font-size: 18px;
        font-weight: bold;
        color: #8993a7;
        line-height: 1em;
        border-bottom: 3px solid transparent;
        cursor: pointer;
    }
   
    .three-boxs{
        width: 33%;
        float: left;
        text-align: center;
        box-sizing: border-box;
        padding: 30px;
        box-sizing: border-box;
    }
    .left-box{
        width: 50%;
        float: left;
        text-align: left;
        box-sizing: border-box;
        padding: 74px;
    }
    .nav-box{
        width: 100%;
        border: 1px solid #dbe0e5;
        box-sizing: border-box;
        padding: 40px;
    }
    .nav-box .list{
        width: 100%;
        margin-bottom: 20px;
        text-align: left;
    }
    .list-item{
        padding: 12px 20px;
        color: #8993a7;
        margin-right: 20px;
        margin-bottom: 20px;
        display: inline-block;
        background: #ffffff;
        border: 1px solid #d0d7e1;
        -webkit-box-shadow: 0px 3px 7px 0px rgba(189, 230, 202, 0.35);
        box-shadow: 0px 3px 7px 0px rgba(189, 230, 202, 0.35);
        min-width: 120px;
        text-align: center;
        position: relative;
            font-size: 12px;
    width: 150px;
    }
    .img_index03{
        width:223px;
        height:auto;
        position:absolute;
        right: 405px;
        top: 97px;
        z-index: 2;
    }

    .img_index04{
        width: auto;
        height: 94%;
        position: absolute;
        top: 0;
        right: 65%;
        margin-top: 1%;
    }
        .img_index06{
        width:223px;
        height:auto;
        position:absolute;
        right: 205px;
        top: 97px;
        z-index: 2;
    }
    .img_index07{
    width: 223px;
    height: auto;
    position: absolute;
    left: 165px;
    top: 229px;
    z-index: 2;
    }
    .img_index09{
        width:223px;
        height:auto;
        position:absolute;
        right: 205px;
        top: -205px;
        z-index: 2;
    }
    .active{
        border-bottom: 3px solid #f8a811 !important;
        color: #333 !important;
    }
    .left-line{
        width: 127px;
    height: 2px;
    background: #C7C7C7;
    display: inline-block;
    position: absolute;
    left: 305px;
    top: 20px;
    }
    .right-line{
        width: 127px;
    height: 2px;
    background: #C7C7C7;
    display: inline-block;
    position: absolute;
    right: 308px;
    top: 20px;
    }
</style>